import React from 'react'
import { ThemeProvider } from 'styled-components'
import GlobalStyle from '../../elements/Global'
import { Mobile } from '../MediaQuery'
import Header from '../Header'
import Container from '../Container'
import Navigation from '../Navigation'
import Iconography from '../../config/fontAwesome'
import theme from '../../styles/theme'
import SEO from '../seo'

const Layout = ({ children }) => {
  Iconography()
  return (
    <ThemeProvider theme={theme}>
      <SEO />
      <GlobalStyle />
      <Header />
      <Container main>
        <main>{children}</main>
      </Container>
      <Mobile>
        <Navigation mobile />
      </Mobile>
    </ThemeProvider>
  )
}

export default Layout
